module.exports = __webpack_public_path__ + "static/media/web2.1a765fe8.jpg";